import axios from "axios";
import { apiServicesUrl } from "./baseUrl";
import {  userAccessToken } from "../helpers";

export const fetchExIpas = (filter) => {
  if (!userAccessToken()) return;

  return axios.get(`${apiServicesUrl}/ex-ipa/`, {
    params: {
      page: filter.page,
      per_page: filter.per_page,
      search_term: filter.search_term,
    },
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      Authorization: `Bearer ${userAccessToken()}`,
    },
  });
};

export const updateExIpa = (id, data) => {
  if (!userAccessToken()) return;

  return axios.put(`${apiServicesUrl}/ex-ipa/${id}`, data, {
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      Authorization: `Bearer ${userAccessToken()}`,
    },
  });
};